import { combineEpics } from "redux-observable";
import { push } from "react-router-redux";
import { F } from "ramda";
import { candidate, insider } from "routes/paths";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import * as intercom from "core/integrations/intercom";
import * as linkedinPixel from "core/integrations/linkedin-pixel";
import * as api from "./api";
import * as authActions from "../auth/actions";

export default combineEpics(
  action$ =>
    action$
      .ofType(api.updateWizard.types.success)
      .do(({ payload }) => {
        fbPixel.fbq("trackCustom", "OnboardingCompleted");
        dataLayer.push({
          event: "onboardingComplete"
        });
        intercom.track("onboardingComplete");
        linkedinPixel.track(292521);
      })
      .mapTo(push(candidate.main)),
  action$ =>
    action$
      .ofType(api.getWizard.types.success)
      .do(() => {
        intercom.init();
      })
      .filter(F),
  // TODO: most likely that logic should be in `auth` along with that api
  (action$, store) =>
    action$
      .ofType(api.getWizard.types.failure)
      .map(() =>
        authActions.signOut(store.getState().router.location.pathname)
      ),
  action$ =>
    action$
      .ofType(api.insiderOnboarding.types.success)
      .mapTo(push(insider.insiderDashboardProfile))
);



// WEBPACK FOOTER //
// ./src/modules/user/onboarding/epic.js